import { IExportImportClient, INode } from "@multiweb/clients/exportImport";
import { AppContext } from "../../../../../App";
import { CancellationToken } from "../../../../../Global/Base/Promises/CancellationTokenSource";
import { ASServices } from "../../../../Basic/ServiceEndpoints";
import { getCancellationTokenAsRequestContext } from "../../../RequestContext";
import { BaseClient } from "../BaseClient";

export class ExportImportClient extends BaseClient implements IExportImportClient {
    public async export(jsonData: INode[], cancellationToken: CancellationToken = CancellationToken.none): Promise<string> {
        return this._communicationManager.callPOSTRequest("Export", ASServices.exportImport, undefined, jsonData, undefined, {
            roles: AppContext.instance.activeUserRolesIds,
            cancellationToken: cancellationToken,
        });
    }

    public async import(tempDocID: string, cancellationToken: CancellationToken = CancellationToken.none): Promise<string> {
        return this._communicationManager.callGETRequest("Import", ASServices.exportImport, { tempDocID }, undefined, getCancellationTokenAsRequestContext(cancellationToken));
    }

    public async checkCondition(condition: string, objectName: string, cancellationToken: CancellationToken = CancellationToken.none): Promise<boolean> {
        return this._communicationManager.callPOSTRequest("CheckCondition", ASServices.exportImport, { objName: objectName }, condition, undefined, getCancellationTokenAsRequestContext(cancellationToken));
    }

    public async getClassNames(cancellationToken: CancellationToken = CancellationToken.none): Promise<string[]> {
        return this._communicationManager.callGETRequest("GetClassNames", ASServices.exportImport, { }, undefined, {
            roles: AppContext.instance.activeUserRolesIds,
            cancellationToken: cancellationToken,
        });
    }
}
